var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-list-import-upload"},[_c('ContactImportUpload',{attrs:{"override-import-type":'contact-list',"pageCopy":_vm.page_copy,"fieldDefinitions":_vm.field_definitions,"previewConfig":_vm.preview_config,"targetListName":_vm.target_list_name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }